// Wspólny helper do wgrywania pliku odpowiedzi na S3 i finalizacji w backendzie.
// Zwraca { file_key, meta } gotowe do zapisania w stanie odpowiedzi.
const authHeader = () => ({ 'Authorization': `Bearer ${localStorage.getItem('token') || ''}` });

export async function uploadAnswerBlob({ attemptId, questionId, blob, filename, contentType, extraMeta = {} }) {
    if (!blob || !blob.size) throw new Error('Pusty plik');
    // 1) presign
    const initRes = await fetch(`/api/exam/attempts/${attemptId}/answers/${questionId}/file/initiate`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json', ...authHeader() },
        body: JSON.stringify({ filename, contentType, sizeBytes: blob.size })
    });
    const init = await initRes.json();
    if (!init?.url || !init?.key) throw new Error(init?.blad || 'Błąd inicjalizacji uploadu');

    // 2) PUT do S3
    const put = await fetch(init.url, {
        method: init.method || 'PUT',
        headers: { 'Content-Type': contentType, ...(init.headers || {}) },
        body: blob
    });
    if (!put.ok) {
        const t = await put.text().catch(()=>'(brak treści)');
        throw new Error(`Upload nieudany: ${put.status} ${t}`);
    }

    // 3) finalize
    const meta = {
        name: filename,
        type: contentType,
        size: blob.size,
        ...extraMeta
    };
    const finRes = await fetch(`/api/exam/attempts/${attemptId}/answers/${questionId}/file/finalize`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json', ...authHeader() },
        body: JSON.stringify({ key: init.key, meta })
    });
    const fin = await finRes.json();
    if (!fin?.ok) throw new Error(fin?.blad || 'Błąd finalizacji pliku');

    return { file_key: init.key, meta };
}
